import { render } from "./SavedListSummary.vue?vue&type=template&id=c1cb585a"
import script from "./SavedListSummary.vue?vue&type=script&lang=js"
export * from "./SavedListSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__